import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgGaruda from '../../../assets/images/pngwing.png';
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import imgCheck from "../../../assets/images/icons/check.png"
import imgCheckBox from "../../../assets/images/icons/checkbox_blank_outline_icon.png"
import imgCheckBoxIcon from "../../../assets/images/icons/checkbox_icon.png"
import DraftAppendix from "./DraftAppendix";
import GetDokumen from "../../../utilities/GetDokumen";
import Kemasan from "../../../utilities/Kemasan";
import KotaKab from "../../../utilities/KotaKab";
import Propinsi from "../../../utilities/Propinsi";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    textRefNo: {
        fontSize: 7,
        textAlign: "right",
        marginRight: 75
    },
    textBox: {
        fontSize: 7,
    },
    textBoxSign: {
        fontSize: 7,
    },
    textBoxInf: {
        fontSize: 7,
        textAlign: "left",
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableInf0: {
        borderRight: '1 solid black',
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '5%',
    },
    tableInf1: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf2: {
        border: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf3: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableInf4: {
        border: '1 solid black',
        display: 'table',
        width: '15%',
    },
    tableInf5: {
        borderTop: '1 solid black',
        borderBottom: '1 solid black',
        display: 'table',
        width: '20%',
    },
    tableCon1: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableCon2: {
        borderBottom: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableCer1: {
        display: 'table',
        width: '60%',
    },
    tableCer2: {
        display: 'table',
        width: '50%',
    },
    tableCer3: {
        display: 'table',
        width: '100%',
        borderBottom: 1,
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableRowSign: {
        flexDirection: 'row',
        marginTop: 30
    },
    tableRowSignName: {
        flexDirection: 'row',
        marginTop: 30
    },
    tableCol1: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '5%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol3: {
        width: '60%',
        padding: 5,
        textAlign: 'left',
    },
    tableColTX1: {
        width: '28%',
        padding: 2,
        textAlign: 'left',
    },
    tableColTX2: {
        width: '25%',
        padding: 2,
        textAlign: 'left',
    },
    tableColTX3: {
        width: '40%',
        padding: 2,
        textAlign: 'left',
    },
    tableBox: {
        width: 'auto',
        display: 'table'
    },
    textEn: {
        fontSize: 7,
        textAlign: "left",
        textDecoration: "underline"
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "left",
    },
    textEnInf: {
        fontSize: 7,
        textAlign: "center",
    },
    textInInf: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "center",
    },
    textEnCenter: {
        fontSize: 7,
        textAlign: "center",
        textDecoration: "underline"
    },
    textInCenter: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "center",
    },
    tableColBox1: {
        width: '35%',
        padding: 2,
        textAlign: 'left',
    },
    tableColBox2: {
        width: '5%',
        padding: 2,
        textAlign: 'left',
    },
    tableColBox3: {
        width: '55%',
        padding: 5,
        textAlign: 'left',
    },
    tableColBoxCon1: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxCon2: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxCon3: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxInf1: {
        width: '85%',
        borderBottom: '1 solid black',
        textAlign: 'Center',
    },
    tableColBoxInf2: {
        width: '85%',
        padding: 5,
        textAlign: 'Center',
    },
    tableColBoxAtt: {
        width: '85%',
        textAlign: 'left',
    },
    tableColBoxSign1: {
        width: '5%',
        textAlign: 'left',
    },
    tableColBoxSign2: {
        width: '25%',
        textAlign: 'left',
    },
    tableColBoxSign3: {
        width: '30%',
        textAlign: 'left',
    },
    tableColBoxSign5: {
        width: '50%',
        textAlign: 'center',
    },
    tableboxSign: {
        width: 'auto',
        display: 'table',
        marginTop: 15
    },
    checkicon: {
        width: 12,
        height: 12
    }
})

const DraftG = ({ dataDisposisi, datappm, qrImage }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [totalJumlah, setTotalJumlah] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resTotal,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd,
                resMutuArea
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setTotalJumlah(getData(resTotal));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuProd(getData(resMutuProd));
            setPpmMutuArea(getData(resMutuArea))

        } catch (error) {
            console.error("Gagal memuat data:", error);
        }

    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    // useEffect(() => {
    //     if (!datappm) return
    //     const fetchAllData = async () => {
    //         try {
    //             let jsonMutuPK = {
    //                 nomorAju: datappm.nomorAju,
    //                 noProses: dataDisposisi.noTugas
    //             }
    //             const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
    //             setDataHc(resHc.data)

    //             const resUpt = await userService.getUptById(datappm.kdUpt)
    //             // console.log(resUpt)
    //             setUpt(resUpt.data)

    //             const resNeg = await masterService.getNegaraById(datappm.negaraPartner)
    //             setNegaraTujuan(resNeg.data)

    //             const jsonPelMuat = {
    //                 jnsPelabuhan: "D",
    //                 kodePelabuhan: datappm.pelabuhanMuat
    //             }
    //             const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelMuat))
    //             setPelMuat(resPelDn.data)

    //             const jsonPelLn = {
    //                 jnsPelabuhan: "L",
    //                 kodePelabuhan: datappm.pelabuhanBongkar
    //             }
    //             const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
    //             setPelBongkar(resPelLn.data)

    //             const resDetil = await transaksiService.listPpmDetilAll(datappm.nomorAju)
    //             setPpmDetil(resDetil.data.data)

    //             const resTotal = await transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju)
    //             setTotalJumlah(resTotal.data.data)

    //             const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
    //             setPpmMutu(resMutu.data)

    //             const resMutuProd = await transaksiService.listPpmMutuProdAll(datappm.nomorAju)
    //             setPpmMutuProd(resMutuProd.data.data)

    //             const resKemasanAll = await transaksiService.listPpmKemasanAll(datappm.nomorAju)
    //             setPpmKemasan(resKemasanAll.data.data)

    //             const resKontainer = await transaksiService.listPpmContainerAll(datappm.nomorAju)
    //             setPpmKontainer(resKontainer.data.data)

    //             const resMutuArea = await transaksiService.getPpmMutuAreaById(datappm.nomorAju)
    //             setPpmMutuArea(resMutuArea.data)

    //         } catch (error) {
    //             console.log(error)
    //         }
    //     }
    //     fetchAllData()
    // }, [datappm, transaksiService, masterService, userService, dataDisposisi])

    return (
        <Document>
            <Page size="LEGAL" style={styles.page} wrap={false}>
                <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={styles.headingEn}>THE REPUBLIC OF INDONESIA</Text>
                    <Text style={styles.headingIn}>REPUBLIK INDONESIA</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                    <Text style={styles.headingIn}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>HEALTH CERTIFICATE</Text>
                    <Text style={styles.headingIn}>SERTIFIKAT KESEHATAN</Text>
                </View>
                <View>
                    <Text style={styles.headingEn}>For fishery product originated from Indonesia and intended for export to Taiwan /</Text>
                    <Text style={styles.headingIn}>Untuk hasil perikanan yang berasal dari Indonesia dan ditujukan untuk ekspor ke Taiwan </Text>
                </View>
                <View style={styles.tableBox}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColTX1}>
                            <Text style={styles.textEn}>I. CONSIGNMENT INFORMATION</Text>
                        </View>
                        <View style={styles.tableColTX2}>
                            <Text style={styles.textIn}>/ INFORMASI PENGIRIMAN</Text>
                        </View>
                        <View style={styles.tableColTX3}>
                            <Text style={styles.textRefNo}>Reference No: {dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCon1}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Name of Consignor</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>/ Nama Pengirim</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Address</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>/Alamat</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Tel</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>/Telp</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon3}>
                                        <Text style={styles.textBox}>{dataHc !== null ? dataHc.telpPengirim : ''}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.tableCon2}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Name of Consignee</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>/ Nama Penerima</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Address</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>/Alamat</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Tel</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>/Telp</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon3}>
                                        <Text style={styles.textBox}>{dataHc !== null ? dataHc.telpPenerima : ''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Competent Authority The Exporting Country</Text>
                                <Text style={styles.textIn}>Otoritas Kompeten Negara Eksportir</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Address</Text>
                                <Text style={styles.textIn}>Alamat</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>Jl. Medan Merdeka Timur No. 16, Jakarta. Telp. +6221-3520351</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Local Competent Authority</Text>
                                <Text style={styles.textIn}>Otoritas Kompeten Daerah</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{upt !== null ? upt.nmInggris : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox1}>
                                <Text style={styles.textEn}>Address</Text>
                                <Text style={styles.textIn}>Alamat</Text>
                            </View>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>:</Text>
                            </View>
                            <View style={styles.tableCol3}>
                                <Text style={styles.textBox}>{upt !== null ? upt.alamatUnit : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCon1]}>
                                <View style={[styles.tableRow, { borderTop: 1 }]}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Description of Goods</Text>
                                        <Text style={styles.textIn}>/ Kondisi Barang</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.mutuDesk : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Weight Declared (kg):</Text>
                                        <Text style={styles.textIn}>Berat Timbangan (kg)</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon3}>
                                        {/* <Text style={styles.textBox}>{dataHc !== null ? dataHc.netto : ''} KGS</Text> */}
                                        <Text style={styles.textBox}>
                                            {
                                                totalJumlah.map((detil, index) => {
                                                    return (
                                                        detil.totalJumlah + ' ' + detil.kodeSatuan.toUpperCase() + ';'
                                                    )
                                                })
                                            }
                                        </Text>
                                    </View>
                                </View>
                            </View>
                            <View style={[styles.tableCon2, { borderTop: 1 }]}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Temperature of product :</Text>
                                        <Text style={styles.textIn}>Temperatur Barang</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEnInf}>{ppmMutu !== null ? ppmMutu.mutuTemp : ''}</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Ambient</Text>
                                        <Text style={styles.textIn}>Ruang</Text>
                                    </View>
                                    {
                                        ppmMutu !== null && ppmMutu.mutuTempTipe === '1' &&
                                        <View style={styles.tableColBoxCon2}>
                                            <Image src={imgCheck} style={styles.checkicon} />
                                        </View>
                                    }
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textEn}>Chilled</Text>
                                        <Text style={styles.textIn}>Dingin</Text>
                                    </View>
                                    {
                                        ppmMutu !== null && ppmMutu.mutuTempTipe === '2' &&
                                        <View style={styles.tableColBoxCon2}>
                                            <Image src={imgCheck} style={styles.checkicon} />
                                        </View>
                                    }
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textEn}>Frozen</Text>
                                        <Text style={styles.textIn}>Beku</Text>
                                    </View>
                                    {
                                        ppmMutu !== null && ppmMutu.mutuTempTipe === '3' &&
                                        <View style={styles.tableColBoxCon2}>
                                            <Image src={imgCheck} style={styles.checkicon} />
                                        </View>
                                    }
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCon1}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Aquaculture Area</Text>
                                        <Text style={styles.textIn}>Area Budidaya</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    {/* <Text style={styles.textBox}>{dataHc !== null ? dataHc.culturedArea : '-'}</Text> */}
                                    <Text style={styles.textBox}>
                                        {
                                            ppmMutuArea !== null ? (ppmMutuArea[0].mutuArea === '1' ? <><KotaKab id={ppmMutuArea[0].mutuCultKota} />, <Propinsi id={ppmMutuArea[0].mutuCultProp} /></> : '') : ''
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.tableCon2}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Catch Area</Text>
                                        <Text style={styles.textIn}>Area Tangkap</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    {/* <Text style={styles.textBox}>{dataHc !== null ? dataHc.catchArea : '-'}</Text> */}
                                    <Text style={styles.textBox}>
                                        {
                                            ppmMutuArea !== null ? (ppmMutuArea[0].mutuArea === '2' ? <>{ppmMutuArea[0].mutuTangkapArea}</> : '') : ''
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCer3}>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "100%" }]}>
                                    <Text style={styles.textEn}>Commodities certified for :</Text>
                                    <Text style={styles.textIn}>Sertifikat Komoditi untuk</Text>
                                </View>
                            </View>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "40%" }]}>
                                    <Text>&nbsp;</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "25%" }]}>
                                    <Text style={styles.textEn}>Human consumption</Text>
                                    <Text style={styles.textIn}>Dikonsumsi manusia</Text>
                                </View>
                                {
                                    datappm !== null && datappm.peruntukan === '1' &&
                                    <View style={[styles.tableCol, { width: "10%" }]}>
                                        <Image src={imgCheck} style={styles.checkicon} />
                                    </View>
                                }
                            </View>
                            <View style={styles.tableRow}>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={styles.textEn}>Place of Destination (port) : </Text>
                                    <Text style={styles.textIn}>Tempat Tujuan (pelabuhan)</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "80%" }]}>
                                    <Text style={styles.textIn}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}, {negaraTujuan !== null ? negaraTujuan.uraianNegara : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCer3}>
                            <View style={[styles.tableRow, { borderTop: 1 }]}>
                                <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>No.</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Species (Scientific Name)/</Text>
                                    <Text style={styles.textInInf}>Spesies (Nama Latin)</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Type of packages/</Text>
                                    <Text style={styles.textInInf}>Jenis Kemasan</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Number of packages/</Text>
                                    <Text style={styles.textInInf}>Nomor Kemasan</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                    <Text style={styles.textEnInf}>Net weight (kg)</Text>
                                    <Text style={styles.textInInf}>Berat Bersih (kg)</Text>
                                </View>
                                <View style={[styles.tableCol, { width: "23%" }]}>
                                    <Text style={styles.textEnInf}>Date (period) of Production</Text>
                                    <Text style={styles.textInInf}>Tanggal (Periode) Produksi</Text>
                                </View>
                            </View>
                            {
                                ppmDetil.length <= 3 ?
                                    (
                                        ppmDetil.map((detil, index) => {
                                            return (
                                                <>
                                                    <View key={index} style={[styles.tableRow]}>
                                                        <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                            <Text style={styles.textEnInf}>{index + 1}</Text>
                                                        </View>
                                                        <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                            <Text style={[styles.textInInf]}>{detil.namaLatin}</Text>
                                                        </View>
                                                        {
                                                            index === 0 ?
                                                                (
                                                                    <>
                                                                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                            {
                                                                                ppmKemasan.map((kms, idxKms) => {
                                                                                    return (
                                                                                        <>
                                                                                            <Text key={idxKms} style={[styles.textEnInf]}>{<Kemasan id={kms.kodeKemasan} />}</Text>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </View>
                                                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                            {
                                                                                ppmKemasan.map((kms, idxKms) => {
                                                                                    return (
                                                                                        <>
                                                                                            <Text key={idxKms} style={[styles.textEnInf]}>{kms.jumlah}</Text>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </View>
                                                                    </>
                                                                ) :
                                                                (
                                                                    <>
                                                                        <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                                                            <Text style={[styles.textEnInf]}></Text>
                                                                        </View>
                                                                        <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                                                                            <Text style={[styles.textEnInf]}></Text>
                                                                        </View>
                                                                    </>
                                                                )
                                                        }
                                                        <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                            <Text style={[styles.textEnInf]}>{detil.jumlah} {detil.kodeSatuan}</Text>
                                                        </View>
                                                        {
                                                            index === 0 ?
                                                                (
                                                                    <View style={[styles.tableCol, { width: "23%", borderTopWidth: 1 }]}>
                                                                        {
                                                                            ppmMutuProd.length <= 3 ?
                                                                                (
                                                                                    ppmMutuProd.map((mutuProd, index) => {
                                                                                        return (
                                                                                            <Text key={index} style={[styles.textEnInf]}>
                                                                                                {mutuProd.mutuProdTgl}
                                                                                            </Text>
                                                                                        )
                                                                                    })
                                                                                ) :
                                                                                (
                                                                                    <Text key={index} style={[styles.textEnInf]}>
                                                                                        See Appendix
                                                                                    </Text>
                                                                                )
                                                                        }
                                                                        {/* <Text style={[styles.textEnInf]}>
                                                                            {
                                                                                ppmMutuProd.map((mutuProd, index) => {
                                                                                    return (
                                                                                        <Text key={index} style={[styles.text]}>
                                                                                            {mutuProd.mutuProdTgl}
                                                                                        </Text>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </Text> */}
                                                                    </View>

                                                                ) :
                                                                (

                                                                    <View style={[styles.tableCol, { width: "23%" }]} />
                                                                )
                                                        }
                                                    </View>
                                                </>
                                            )
                                        })
                                    ) :
                                    (
                                        <>
                                            <View style={[styles.tableRow]}>
                                                <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={styles.textEnInf}></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textInInf]}>See Appendix</Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                                <View style={[styles.tableCol, { width: "23%", borderTopWidth: 1 }]}>
                                                    <Text style={[styles.textEnInf]}></Text>
                                                </View>
                                            </View>
                                        </>
                                    )
                            }
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEn}>Name of the Establishment (Producer)</Text>
                            </View>
                            <View style={styles.tableColBoxCon2}>
                                <Text style={styles.textIn}>/Nama UPI Produsen :</Text>
                            </View>
                            <View style={styles.tableColBoxCon3}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColBoxCon1, { width: '10%' }]}>
                                <Text style={styles.textEn}>Address</Text>
                            </View>
                            <View style={[styles.tableColBoxCon2, { width: '10%' }]}>
                                <Text style={styles.textIn}>Alamat:</Text>
                            </View>
                            <View style={[styles.tableColBoxCon3, { width: "75%" }]}>
                                <Text style={styles.textBox}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEn}>The Products will be processed and exported to/</Text>
                                <Text style={styles.textIn}>Produk akan diolah dan diekspor ke</Text>
                            </View>
                            <View style={styles.tableColBoxCon2}>
                                <Text style={styles.textIn}>:</Text>
                            </View>
                            {
                                ppmMutu !== null && ppmMutu.upiNoRegUe !== null && ppmMutu.upiNoRegUe !== '' ?
                                    (
                                        <View style={styles.tableColBoxCon3}>
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        </View>
                                    ) :
                                    (
                                        <View style={styles.tableColBoxCon3}>
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                        </View>

                                    )
                            }
                            <View style={styles.tableColBoxCon3}>
                                <Text style={styles.textBox}>EU</Text>
                            </View>
                            {
                                ppmMutu !== null && ppmMutu.upiNoRegUe !== null && ppmMutu.upiNoRegUe !== '' ?
                                    (
                                        <View style={styles.tableColBoxCon3}>
                                            <Image src={imgCheckBox} style={styles.checkicon} />
                                        </View>
                                    ) :
                                    (
                                        <View style={styles.tableColBoxCon3}>
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        </View>

                                    )
                            }
                            <View style={styles.tableColBoxCon3}>
                                <Text style={styles.textBox}>Non EU</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEn}>EU Approval Number</Text>
                            </View>
                            <View style={styles.tableColBoxCon2}>
                                <Text style={styles.textIn}>/Nomor Persetujuan UE :</Text>
                            </View>
                            <View style={styles.tableColBoxCon3}>
                                <Text style={styles.textBox}>{ppmMutu !== null ? ppmMutu.upiNoRegUe : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCon1, { borderTop: 1, borderRightWidth: 0, width: '25%' }]}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Container No/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>No. Kontainer</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        <View key={index} style={styles.tableCol}>
                                                            <Text style={styles.textEn}>
                                                                {kont.nomor};
                                                            </Text>
                                                        </View>
                                                    </>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableCon1, { borderTop: 1, width: '25%', borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Bill Of Lading No/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>No Dokumen Muat</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>
                                        {datappm !== null ? (<GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'705'} /> === '' ? <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'704'} /> : <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'705'} />) : ''}
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableCon2, { borderTop: 1, borderRightWidth: 0, width: '20%' }]}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Seal No/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>No. Segel:</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        <View key={index} style={styles.tableCol}>
                                                            <Text style={styles.textEn}>
                                                                {kont.nomorSegel};
                                                            </Text>
                                                        </View>
                                                    </>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableCon2, { borderTop: 1, width: '30%' }]}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Mean of Conveyance/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>Cara Pengiriman</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>
                                        <Text style={styles.text}>{dataHc !== null ? dataHc.nmTrans : ''} / Voyage : {dataHc !== null ? dataHc.noFlight : ''}</Text>
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCon1}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Place of Dispatch (port)/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>Tempat Pengiriman (pelabuhan):</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{pelMuat !== null ? pelMuat.uraianPelabuhan : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableCon2}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Place of Destination (port)/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>Tempat Tujuan (pelabuhan):</Text>
                                    </View>
                                </View>
                                <View style={styles.tableColBoxCon3}>
                                    <Text style={styles.textBox}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCer1}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>Date of Dispatch/</Text>
                                    </View>
                                    <View style={styles.tableColBoxCon2}>
                                        <Text style={styles.textIn}>Tanggal Pengiriman:</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.tableCer2}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textBox}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.tableColBoxCon3}>
                                <Text style={styles.textBox}></Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableBox}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEn}>II. Health Attestation/ Pernyataan Kesehatan</Text>
                                <Text style={styles.textIn}>This is to certify that/Dengan ini menerangkan bahwa :</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>1.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textEn}>The above fishery product come from the establishment approved by the Marine And Fisheries Quality Assurance Agency and met EU requirements (*)</Text>
                                <Text style={styles.textIn}>Produk perikanan diatas berasal dari Unit Pengolahan Ikan (UPI) disetujui oleh Badan Pengendalian Dan Pengawasan Mutu Hasil Kelautan Dan Perikanan dan sesuai persyaratan UE(*)</Text>
                                <Text style={styles.textEn}>(*) In case the product would be used for further processing to export to EU, the underlined clause should be kept.</Text>
                                <Text style={styles.textIn}>(*) Jika produk akan digunakan untuk pengolahan lebih lanjut untuk ekspor ke UE, ketentuan yang digaris bawahi harus berlaku.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>2.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textEn}>The product were produced, packed, stored and transported under sanitary condition, which were under the supervision and inspection of the Marine And Fisheries Quality Assurance Agency.</Text>
                                <Text style={styles.textIn}>Produk telah diproduksi, dikemas, disimpan dan diangkut dalam keadaan bersih/sehat, yang mana berada di bawah pengawasan dan pemeriksaan Badan Pengendalian Dan Pengawasan Mutu Hasil Kelautan Dan Perikanan.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textBox}>3.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textEn}>The product were inspected by Inspection Agency and not found any pathogenic bacteria, harmful substances and fit for human consumption.</Text>
                                <Text style={styles.textIn}>Produk telah diperiksa oleh Badan Pemeriksa dan tidak ditemukan adanya bakteri pathogen, unsur-unsur yang membahayakan dan aman untuk konsumsi manusia</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={styles.tableboxSign}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textEn}></Text>
                            <Text style={styles.textIn}></Text>
                        </View>
                        <View style={styles.tableColBoxSign1}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textEn}>Date of issue/ Dikeluarkan tanggal :</Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}>{upt !== null ? upt.kota : ''}, {dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRowSign}>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign5}>
                            <Text style={[styles.textBoxSign, { width: "100%" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                            <Text style={styles.textEnCenter}>Signature of the official inspector</Text>
                            <Text style={styles.textInCenter}>Tanda tangan Inspektur Mutu</Text>
                        </View>
                        <View style={styles.tableColBoxSign2}>
                            <Text style={styles.textBox}></Text>
                        </View>
                        <View style={styles.tableColBoxSign3}>
                            <Text style={styles.textBox}></Text>
                        </View>
                    </View>
                </View>
            </Page>
            {
                (ppmDetil.length > 3 || ppmMutuProd.length > 3) &&
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} ppmMutuProd={ppmMutuProd} />
                </>
            }
        </Document>
    )
}

export default DraftG